module.exports = __webpack_public_path__ + "assets/8797e0c49cdb5bce17c935d5571e7023.png";